// Initial tool directory data
export const toolsData = [
  {
    id: 'etera',
    title: 'Etera',
    icon: '🔗',
    description: '**ETERA is the single destination for permanent, dynamic QR codes.** Buy once, own for life, and update your destination URL anytime. Made by me.',
    category: 'my-tools',
    price: 'Lifetime Deal',
    priceType: 'lifetime',
    tags: ['Marketing', 'QR Codes', 'Dynamic'],
    actions: [
      { label: 'Get Deal', url: 'https://etera.store/', type: 'btn-primary' }
    ]
  },
  {
    id: 'glorify',
    title: 'Glorify',
    icon: '🎨',
    description: 'The **ultimate design tool for e-commerce**. Create professional product images, marketing assets, and brand content with a specialized Canva-like interface designed for sellers.',
    category: 'marketing',
    price: 'Subscription',
    priceType: 'subscription',
    tags: ['Marketing', 'E-commerce', 'Design'],
    actions: [
      { label: 'View Tool', url: 'https://www.glorify.com?ref=mdvlymv', type: 'btn-primary' }
    ]
  },
  {
    id: 'magicfit',
    title: 'MagicFit',
    icon: '🎬',
    description: 'Create **high-converting AI UGC (User Generated Content) videos** and more. Transform your marketing with realistic AI-driven video content that drives engagement and sales.',
    category: 'lifetime',
    price: 'Lifetime Deal',
    priceType: 'lifetime',
    tags: ['Marketing', 'AI', 'Video', 'UGC'],
    actions: [
      { label: 'Get Deal', url: 'https://appsumo.8odi.net/zz4oOW', type: 'btn-primary' }
    ]
  },
  {
    id: 'finetuning',
    title: 'FineTuning',
    icon: '🎵',
    description: '**AI-powered music generation platform** with a lifetime deal. Create high-quality, royalty-free tracks and unique audio compositions for your content in seconds.',
    category: 'lifetime',
    price: 'Lifetime Deal',
    priceType: 'lifetime',
    tags: ['AI', 'Music Generation', 'Audio'],
    actions: [
      { label: 'Get Deal', url: 'https://appsumo.8odi.net/rEG255', type: 'btn-primary' }
    ]
  },
  {
    id: 'buildin',
    title: 'Buildin',
    icon: '🛠️',
    description: 'Notion alternative. Create docs, databases, mind maps, and project timelines in one flexible workspace. Use AI tools to search and write faster, then sell paid subscriptions from the same platform.',
    category: 'lifetime',
    price: 'subscription',
    priceType: 'subscription',
    tags: ['Business', 'Notion Alternative', 'AI', 'Productivity'],
    actions: [
      { label: 'Get Deal', url: 'https://buildin.ai/affiliate?via=mathias', type: 'btn-primary' }
    ]
  },
  {
    id: 'Mootion',
    title: 'Mootion',
    icon: '🎬',
    description: 'AI Video Generator.Generate a full video story from a single prompt — no extra steps needed.',
    category: 'design',
    price: 'subscription',
    priceType: 'subscription',
    tags: ['AI', 'Video'],
    actions: [
      { label: 'View Tool', url: 'https://www.mootion.com/?via=mathias', type: 'btn-primary' }
    ]
  },
  {
    id: 'picsart',
    title: 'Picsart',
    icon: '🎨',
    description: 'Comprehensive **all-in-one AI photo and video editing platform.** Create professional-quality designs, social media posts, and creative content with powerful AI-driven tools.',
    category: 'design',
    price: 'Subscription',
    priceType: 'subscription',
    tags: ['Design', 'Photo Editing', 'Video Editing', 'AI'],
    actions: [
      { label: 'View Tool', url: 'https://imp.i326929.net/aN12zQ', type: 'btn-primary' }
    ]
  },
  {
    id: 'Google-Workplace',
    title: 'Google Workplace',
    icon: '🎤',
    description: 'Comprehensive business suite including **Gmail**, **Google Meet**, **Drive storage**, and **Gemini AI** integration for seamless productivity.',
    category: 'productivity',
    price: 'subscription',
    priceType: 'subscription',
    tags: ['Calls'],
    actions: [
      { label: 'View Tool', url: 'https://referworkspace.app.goo.gl/Px4M', type: 'btn-primary' }
    ]
  },
  {
    id: 'Greta',
    title: 'Greta',
    icon: '🎤',
    description: 'Revolutionary **no-code website and webapp builder**. Build anything with just a prompt - from landing pages to complex applications without writing a single line of code.',
    category: 'development',
    price: 'Subscription',
    priceType: 'subscription',
    tags: ['AI', 'Coding', 'Builder'],
    actions: [
      { label: 'View Tool', url: 'http://greta.questera.ai/?via=mathias', type: 'btn-primary' }
    ]
  },
  {
    id: 'hedy-ai',
    title: 'Hedy AI',
    icon: '🎤',
    description: 'AI-powered conversation coach to help you speak with **clarity, confidence, and impact** in every meeting, interview, class, or pitch.',
    category: 'productivity',
    price: 'Lifetime Deal',
    priceType: 'lifetime',
    tags: ['AI', 'Coaching', 'Calls'],
    actions: [
      { label: 'Get Lifetime Deal', url: 'https://appsumo.8odi.net/qWWj0L', type: 'btn-primary' }
    ]
  },
  {
    id: 'story-wraith',
    title: 'Story Wraith',
    icon: '📚',
    description: '**AI-Powered Book Writer** currently in production. Revolutionary tool for authors to create compelling narratives with artificial intelligence assistance.',
    category: 'my-tools',
    price: 'Custom Built',
    priceType: 'custom',
    tags: ['Writing', 'AI', 'Books'],
    actions: [
      { label: 'View Tool', url: 'https://storywrait.art/', type: 'btn-primary' },
      { label: 'Join Waitlist', url: 'https://sendfox.com/lp/m5202q', type: 'btn-secondary' }
    ]
  },
  {
    id: 'char-manager',
    title: 'Char Manager',
    icon: '👥',
    description: 'Comprehensive **character management tool for authors** - currently in production. Organize character arcs, relationships, and development seamlessly.',
    category: 'my-tools',
    price: 'Custom Built',
    priceType: 'custom',
    tags: ['Writing', 'Character Management', 'Authors'],
    actions: [
      { label: 'Launch Tool', url: 'https://vocal-cocada-47c467.netlify.app/#', type: 'btn-primary' },
      { label: 'Join Waitlist', url: 'https://sendfox.com/lp/1djlqk', type: 'btn-secondary' }
    ]
  },
  {
    id: 'pexels',
    title: 'Pexels',
    icon: '📸',
    description: 'Massive library of **free stock videos and pictures** for content creators. High-quality assets without licensing restrictions.',
    category: 'free',
    price: 'Free',
    priceType: 'free',
    tags: ['Marketing', 'Stock Photos', 'Videos'],
    actions: [
      { label: 'Visit Site', url: 'https://www.pexels.com/', type: 'btn-primary' }
    ]
  },
  {
    id: 'notion',
    title: 'Notion',
    icon: '📝',
    description: '**All-in-one workspace** for notes, tasks, wikis, and databases. Organize your entire life and business in one flexible, powerful platform.',
    category: 'free',
    price: 'Free',
    priceType: 'free',
    tags: ['Database', 'Business', 'Productivity'],
    actions: [
      { label: 'Visit Site', url: 'https://www.notion.com/product', type: 'btn-primary' }
    ]
  },
  {
    id: 'github',
    title: 'GitHub',
    icon: '💻',
    description: '**Where the world builds software.** Millions of developers use GitHub to collaborate, version control, and build amazing projects together.',
    category: 'development',
    price: 'Free',
    priceType: 'free',
    tags: ['Database', 'Business', 'Development'],
    actions: [
      { label: 'Visit Site', url: 'https://github.com/', type: 'btn-primary' }
    ]
  },
  {
    id: 'luminar-neo',
    title: 'Luminar Neo',
    icon: '🎨',
    description: 'Powerful **AI photo editing software** designed for photographers. Advanced AI-powered tools for professional-quality image enhancement and creative editing.',
    category: 'lifetime',
    price: 'Lifetime Deal',
    priceType: 'lifetime',
    tags: ['Marketing', 'Photo Editing', 'AI'],
    actions: [
      { label: 'Get Deal', url: 'https://skylum.evyy.net/c/3859649/2133249/3255', type: 'btn-primary' }
    ]
  },
  {
    id: 'surfast-video-downloader',
    title: 'Surfast Video Downloader',
    icon: '📥',
    description: 'Effortlessly **download videos, audio, thumbnails, and subtitles** from over 1,000 sites, including YouTube, Instagram, Facebook, TikTok, and X.',
    category: 'lifetime',
    price: 'Lifetime Deal',
    priceType: 'lifetime',
    tags: ['Marketing', 'Video Download', 'Social Media'],
    actions: [
      { label: 'Get Deal', url: 'https://appsumo.8odi.net/ra3Eyy', type: 'btn-primary' }
    ]
  },
  {
    id: 'xnapper',
    title: 'Xnapper',
    icon: '📷',
    description: 'Create **stunning, ready-to-share screenshots** in seconds. Perfect for social media, documentation, and professional presentations.',
    category: 'lifetime',
    price: 'Lifetime Deal',
    priceType: 'lifetime',
    tags: ['Marketing', 'Screenshots', 'Design'],
    actions: [
      { label: 'Get Deal', url: 'https://appsumo.8odi.net/OeQYjW', type: 'btn-primary' }
    ]
  },
  {
    id: 'sendfox',
    title: 'Sendfox',
    icon: '📧',
    description: '**Simple, effective newsletter and email marketing tool** built for creators. No complexity, just results-driven email campaigns.',
    category: 'lifetime',
    price: 'Lifetime Deal',
    priceType: 'lifetime',
    tags: ['Marketing', 'Email'],
    actions: [
      { label: 'Get Deal', url: 'https://appsumo.8odi.net/qnrj5N', type: 'btn-primary' }
    ]
  },
  {
    id: 'nodeland',
    title: 'Nodeland',
    icon: '🧠',
    description: '**AI-powered mind mapping tool** that transforms your ideas into structured visual maps. Perfect for brainstorming, planning, and organizing complex projects.',
    category: 'lifetime',
    price: 'Lifetime Deal',
    priceType: 'lifetime',
    tags: ['Marketing', 'AI', 'Mindmap'],
    actions: [
      { label: 'Get Deal', url: 'https://appsumo.8odi.net/DKDPD5', type: 'btn-primary' }
    ]
  },
  {
    id: 'writecream',
    title: 'Writecream',
    icon: '✍️',
    description: '**SEO-optimized AI copywriting tool** that creates compelling content for blogs, ads, emails, and social media with intelligent keyword integration.',
    category: 'lifetime',
    price: 'Lifetime Deal',
    priceType: 'lifetime',
    tags: ['Marketing', 'AI', 'Copywriting'],
    actions: [
      { label: 'Get Deal', url: 'https://appsumo.8odi.net/jez4ZP', type: 'btn-primary' }
    ]
  },
  {
    id: 'magic-bookifier',
    title: 'Magic Bookifier',
    icon: '📚',
    description: '**AI non-fiction book writer** that helps you create professional how-to books in one afternoon. Transform your expertise into published content.',
    category: 'lifetime',
    price: 'Lifetime Deal',
    priceType: 'lifetime',
    tags: ['Writing', 'Marketing', 'AI'],
    actions: [
      { label: 'Get Deal', url: 'https://offer.magicbookifier.ai/lifetime-deal/?via=mathias-deppe', type: 'btn-primary' }
    ]
  },
  {
    id: 'resume-me-up',
    title: 'Resume me up',
    icon: '📄',
    description: 'Comprehensive **AI resume creation, job tracking, LinkedIn optimization, and interview preparation** suite for career advancement.',
    category: 'productivity',
    price: 'subscription',
    priceType: 'subscription',
    tags: ['Business', 'Resume', 'AI', 'Job Search'],
    actions: [
      { label: 'Get Deal', url: 'https://resumeup.ai?aff=5O74Dk', type: 'btn-primary' }
    ]
  },
  {
    id: 'go-brunch',
    title: 'Go Brunch',
    icon: '🍳',
    description: 'Get creative and collaborate with **GoBrunch, the ultimate virtual office and community platform** designed for creators and startups.',
    category: 'lifetime',
    price: 'Lifetime Deal',
    priceType: 'lifetime',
    tags: ['Business', 'Virtual Office', 'Collaboration'],
    actions: [
      { label: 'Get Deal', url: 'https://appsumo.8odi.net/OeQYAN', type: 'btn-primary' }
    ]
  },
  {
    id: 'tidycal',
    title: 'Tidycal',
    icon: '📅',
    description: '**Easy-to-use calendar booking tool** that replaces expensive scheduling software. Simple, clean interface with powerful automation features.',
    category: 'lifetime',
    price: 'Lifetime Deal',
    priceType: 'lifetime',
    tags: ['Business', 'Calendar', 'Booking'],
    actions: [
      { label: 'Get Deal', url: 'https://appsumo.8odi.net/2rGo0g', type: 'btn-primary' }
    ]
  },
  {
    id: 'forento',
    title: 'Forento',
    icon: '🎓',
    description: '**All-in-one course and digital product hosting platform.** Host courses, create communities, sell coaching sessions - everything creators need in one place.',
    category: 'productivity',
    price: 'Subscription',
    priceType: 'subscription',
    tags: ['Business', 'Course', 'Digital Products'],
    actions: [
      { label: 'Get Deal', url: 'https://forento.io/?r=MDEPPE', type: 'btn-primary' }
    ]
  },
  {
    id: 'sinosend',
    title: 'Sinosend',
    icon: '📁',
    description: 'Professional **file delivery and transfer tool** for secure, branded file sharing with clients and team members.',
    category: 'productivity',
    price: 'Subscription',
    priceType: 'subscription',
    tags: ['Business', 'File Delivery', 'Transfer'],
    actions: [
      { label: 'Get Deal', url: 'https://sinosend.com?ref=HXJB8B', type: 'btn-primary' }
    ]
  },
  {
    id: 'headway',
    title: 'Headway',
    icon: '📖',
    description: '**15-minute book summaries** of popular business and self-development books. Learn key insights from bestsellers in your spare time.',
    category: 'lifetime',
    price: 'Lifetime Deal',
    priceType: 'lifetime',
    tags: ['Reading', 'Business', 'Learning'],
    actions: [
      { label: 'Get Deal', url: 'https://appsumo.8odi.net/jeB4MZ', type: 'btn-primary' }
    ]
  },
  {
    id: 'nord-vpn',
    title: 'Nord VPN',
    icon: '🔒',
    description: 'Premium **VPN service for secure browsing and privacy protection.** Fast, reliable connections with military-grade encryption worldwide.',
    category: 'productivity',
    price: 'Subscription',
    priceType: 'subscription',
    tags: ['Business', 'VPN', 'Security'],
    actions: [
      { label: 'Get Deal', url: 'https://nordvpn.sjv.io/mathias', type: 'btn-primary' }
    ]
  },
  {
    id: 'supermachine',
    title: 'Supermachine',
    icon: '🎨',
    description: 'Advanced **AI image generation tool with 60+ AI models** including Flux and Midjourney-style capabilities. Professional-quality image creation platform.',
    category: 'design',
    price: 'Subscription',
    priceType: 'subscription',
    tags: ['Image Generation', 'Marketing', 'AI'],
    actions: [
      { label: 'Visit Site', url: 'https://supermachine.art/?ref=mathiasdeppe22', type: 'btn-primary' }
    ]
  },
  {
    id: 'lazybird',
    title: 'Lazybird',
    icon: '🎙️',
    description: '**AI voiceover generation tool** for creating natural-sounding voice content. Perfect for videos, podcasts, and audiobooks with professional quality.',
    category: 'design',
    price: 'Subscription',
    priceType: 'subscription',
    tags: ['Voiceover', 'Marketing', 'AI'],
    actions: [
      { label: 'Visit Site', url: 'https://www.lazybird.app?aff=5O74Dk', type: 'btn-primary' }
    ]
  }
];